import React from 'react';
// import { connect } from 'react-redux';
import TextBox from '../../Basic/TextBox';
import PhoneBox from '../../Enhanced/PhoneBox';

const ContactPersonPhone = ({ name ,disabled}) => {
    return (
        <div>
            <div className="row">
                <div className="col-md-4 col-sm-6">
                    <TextBox name={`${name}FirstName`} title="First name" disabled={disabled}/>
                </div>
                <div className="col-md-4 col-sm-6">
                    <TextBox name={`${name}LastName`} title="Last name" disabled={disabled}/>
                </div>
                <div className="col-md-4 col-sm-6">
                    <PhoneBox name={`${name}PrimaryPhone`} title="Primary phone number" ext="1" disabled={disabled}/>
                </div>
            </div>
        </div>
    );
};
ContactPersonPhone.propTypes = {
    name: React.PropTypes.string.isRequired,
    disabled: React.PropTypes.bool,
};
export default ContactPersonPhone;
